import { render, staticRenderFns } from "./ResourceUsage.vue?vue&type=template&id=faa03ade"
import script from "./ResourceUsage.vue?vue&type=script&lang=js"
export * from "./ResourceUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports